import { React, useRef, useState } from 'react';

import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import ContactPhoneRoundedIcon from '@mui/icons-material/ContactPhoneRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import { Box, Button, IconButton, TextField } from '@mui/material';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';
import { formatFileSize } from '../../utils/numberUtils';
import '../css/invoiceDispute.css';

function ContestacaoFaturasForm() {
    const [notaFiscal, setnotaFiscal] = useState('');
    const [protocolo, setProtocolo] = useState('');
    const [nome, setNome] = useState('');
    const [telefone, setTelefone] = useState('');
    const [isSubmit, setIsSubmit] = useState(false);
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [files, setFiles] = useState([]);
    const [pontoReferencia, setPontoReferencia] = useState('');
    const fileInputRef = useRef(null);

    async function submitContestacaoFaturas(e) {
        e.preventDefault();
        setIsSubmit(true);

        if (notaFiscal.length === 0) {
            handleAlerta({
                status: 'warning',
                message: 'Adicione ao menos uma nota fiscal antes de enviar.'
            });
            setIsSubmit(false);
            return;
        }

        const formData = new FormData();
        formData.append('notaFiscal', notaFiscal);
        formData.append('protocolo', protocolo);
        formData.append('telefone', telefone);
        formData.append('nome', nome);
        formData.append('ponto_referencia', pontoReferencia);

        if (files && files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                formData.append('files', files[i]);
            }
        }

        try {
            const response = await fetchFlask('contestacaoFaturas', formData);
            handleAlerta(response);

            if (response.status === 'success') {
                setnotaFiscal('');
                setProtocolo('');
                setNome('');
                setTelefone('');
                setFiles([]);
                setPontoReferencia('');
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            }
        } finally {
            setIsSubmit(false);
        }
    }

    const handleRemoveFile = (indexToRemove) => {
        setFiles((prev) => prev.filter((_, index) => index !== indexToRemove));
    };

    function handleAlerta(response) {
        setMessage(response.message);
        setStatus(response.status);
        setOpenAlerta(true);
    }

    const filesLabel = files.length > 0 ? `${files.length} arquivo${files.length > 1 ? 's' : ''}` : 'Nenhum anexo';
    const completedFields = [
        notaFiscal,
        protocolo,
        nome,
        telefone
    ].filter(Boolean).length;

    return (
        <Box className='mainBox ui-workflow-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />

            <PageHeader>
                Contestação de Faturas
            </PageHeader>

            <form onSubmit={submitContestacaoFaturas} className='ui-workflow-layout'>
                <Box className='ui-workflow-workspace'>
                    <Box className='ui-workflow-intro'>
                        <Box>
                            <h2>Abertura de contestação</h2>
                        </Box>
                        <p>
                            Registre a fatura contestada, o protocolo e os dados de contato para acompanhar o retorno ao cliente.
                        </p>
                    </Box>

                    <Box className='ui-workflow-panel'>
                        <Box className='ui-heading'>
                            <ReceiptLongRoundedIcon />
                            <Box>
                                <span>Etapa 1</span>
                                <strong>Fatura e protocolo</strong>
                            </Box>
                        </Box>

                        <Box className='ui-fields-grid'>
                            <TextField
                                required
                                label='Nota Fiscal'
                                value={notaFiscal}
                                onChange={e => setnotaFiscal(e.target.value)}
                            />
                            <TextField
                                required
                                label='Protocolo'
                                value={protocolo}
                                onChange={e => setProtocolo(e.target.value)}
                            />
                        </Box>
                    </Box>

                    <Box className='ui-workflow-panel'>
                        <Box className='ui-heading'>
                            <ContactPhoneRoundedIcon />
                            <Box>
                                <span>Etapa 2</span>
                                <strong>Contato do cliente</strong>
                            </Box>
                        </Box>

                        <Box className='ui-fields-grid'>
                            <TextField
                                required
                                label='Nome'
                                value={nome}
                                onChange={e => setNome(e.target.value)}
                            />
                            <TextField
                                required
                                label='Telefone'
                                value={telefone}
                                onChange={e => setTelefone(e.target.value)}
                            />
                            <TextField
                                label='Ponto de Referência'
                                value={pontoReferencia}
                                onChange={e => setPontoReferencia(e.target.value)}
                            />
                        </Box>
                    </Box>

                    <Box className='ui-workflow-panel'>
                        <Box className='ui-heading'>
                            <UploadFileRoundedIcon />
                            <Box>
                                <span>Etapa 3</span>
                                <strong>Evidências anexadas</strong>
                            </Box>
                        </Box>

                        <Box className='invoice-dispute-upload-strip'>
                            <Button
                                variant='outlined'
                                component='label'
                                startIcon={<UploadFileRoundedIcon />}
                                className='invoice-dispute-upload-button'
                            >
                                Escolher Arquivos
                                <input
                                    ref={fileInputRef}
                                    type='file'
                                    hidden
                                    multiple
                                    accept='application/pdf,image/jpeg,image/png'
                                    onChange={(e) => {
                                        const selected = Array.from(e.target.files);
                                        setFiles((prev) => [...prev, ...selected]);
                                        e.target.value = '';
                                    }}
                                />
                            </Button>

                            <Box>
                                <strong>{filesLabel}</strong>
                                <span>PDF, JPG ou PNG para reforçar a contestação.</span>
                            </Box>
                        </Box>

                        {files.length > 0 && (
                            <Box className='invoice-dispute-file-list'>
                                {files.map((file, index) => (
                                    <Box key={`${file.name}-${index}`} className='invoice-dispute-file-item'>
                                        <Box>
                                            <strong>{file.name}</strong>
                                            <span>{formatFileSize(file.size)}</span>
                                        </Box>
                                        <IconButton
                                            size='small'
                                            color='error'
                                            aria-label={`Remover ${file.name}`}
                                            onClick={() => handleRemoveFile(index)}
                                        >
                                            <DeleteRoundedIcon fontSize='small' />
                                        </IconButton>
                                    </Box>
                                ))}
                            </Box>
                        )}
                    </Box>
                </Box>

                <Box className='ui-workflow-summary'>
                    <Box className='ui-heading ui-heading-divided'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão da contestação</strong>
                        </Box>
                    </Box>

                    <Box className='ui-workflow-summary-list'>
                        <Box>
                            <span>Nota fiscal</span>
                            <strong className={!notaFiscal ? 'is-empty' : undefined}>{notaFiscal || 'Não informada'}</strong>
                        </Box>
                        <Box>
                            <span>Protocolo</span>
                            <strong className={!protocolo ? 'is-empty' : undefined}>{protocolo || 'Não informado'}</strong>
                        </Box>
                        <Box>
                            <span>Cliente</span>
                            <strong className={!nome ? 'is-empty' : undefined}>{nome || 'Não informado'}</strong>
                        </Box>
                        <Box>
                            <span>Telefone</span>
                            <strong className={!telefone ? 'is-empty' : undefined}>{telefone || 'Não informado'}</strong>
                        </Box>
                        <Box>
                            <span>Anexos</span>
                            <strong className={files.length === 0 ? 'is-empty' : undefined}>{filesLabel}</strong>
                        </Box>
                    </Box>

                    <Box className='ui-attention'>
                        <ReportProblemRoundedIcon />
                        <p>
                            Revise protocolo e contato antes de enviar. Os anexos são opcionais, mas ajudam a sustentar a contestação.
                        </p>
                    </Box>

                    <Box className='ui-attention is-ok ui-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>{completedFields}/4 preenchidos</strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} startIcon={<SendRoundedIcon />}>
                        Contestar Faturas
                    </SubmitButton>
                </Box>
            </form>
        </Box>
    );
};

export default ContestacaoFaturasForm;
